export default __webpack_public_path__ + "static/media/490.c870e957.png";